<template>
  <div class="tender-actions">
    <v-tooltip bottom max-width="345">
      <template v-slot:activator="{ on, attrs }">
        <Button
          v-bind="attrs"
          size="small"
          type="ghost"
          icon="pencil"
          v-on="on"
          @click.native.stop="editTender(tender.id)"
        />
      </template>
      {{ $t('Edit tender') }}
    </v-tooltip>
    <TenderCardActions
      :tender="tender"
      @invite="editTender(tender.id, 3)"
      @archive="archiveTender(tender.id)"
      @unarchive="unArchiveTender(tender.id)"
      @click.stop
    />
  </div>
</template>

<script>
  import { VTooltip } from 'vuetify/lib';
  import EditIcon from '@/assets/icons/edit.svg';
  import editTender from '@/utils/mixins/edit-tender';
  import factory from '@/utils/api/factory';
  import TenderCardActions from '@/containers/tenders/card/dropdowns/TenderCardActions';
  import { mapActions } from 'vuex';
  import Button from '@/components/ui-v2/Button';

  export default {
    name: 'TenderCardActionsRow',
    components: {
      Button,
      VTooltip,
      TenderCardActions,
    },
    mixins: [editTender],
    props: {
      tender: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        editIcon: EditIcon,
      };
    },
    methods: {
      ...mapActions({
        confirm: 'confirmModal/openModal',
      }),
      unArchiveTender(id) {
        this.confirm({
          title: `${this.$t('Are you sure you want to unarchive')} ”${
            this.tender.name || this.$t('tender')
          }”?`,
          description: this.$t(
            `All tender data will be saved, but you will not be able to invite new bidders. All contractors will receive a notice.`
          ),
          actionText: this.$t('Unarchive tender'),
          style: 'danger',
          action: async () => {
            try {
              await factory('tenders').postInResourcePath(this.tender.id, 'unarchive', {
                id,
              });
              this.$emit('update-tenders', 'archived');
            } catch (e) {
              console.error(e);
            }
          },
        });
      },
      archiveTender(id) {
        this.confirm({
          title: `${this.$t('Are you sure you want to archive')} ”${
            this.tender.name || this.$t('tender')
          }”?`,
          description: this.$t(
            `All tender data will be saved, but you will not be able to invite new bidders. All contractors will receive a notice.`
          ),
          actionText: this.$t('Archive tender'),
          style: 'danger',
          action: async () => {
            try {
              await factory('tenders').postInResourcePath(this.tender.id, 'archive', {
                id,
              });
              this.$emit('update-tenders');
            } catch (e) {
              console.error(e);
            }
          },
        });
      },
    },
  };
</script>
